const getCookieValue = (key) => {
    let value = ''
    // value = document.cookie.split("; ").find((row) => row.startsWith(key))?.split("=")[1];
    value = sessionStorage.getItem(key);
    return value
}
export default getCookieValue